import view from './view.html';

/* @ngInject */
export default function ($timeout, $rootScope) {
	return {
		restrict:                    'A',
		scope:                       true,
		template:                    view,
		controller: /* @ngInject */  ($scope, $element, $attrs) => {
			// Function for collapse ibox
			$scope.showhide = () => {
				let ibox    = $element.closest('div.ibox');
				let icon    = $element.find('i:first');
				let content = ibox.find('div.ibox-content');

				content.slideToggle(200);

				// Toggle icon from up to down
				icon.toggleClass('fa-chevron-up')
				    .toggleClass('fa-chevron-down');

				ibox.toggleClass('')
				    .toggleClass('border-bottom');

				$timeout(() => {
					ibox.resize();

					ibox.find('[id^=map-]')
					    .resize();

					$rootScope.$broadcast('sidebar.triggerResize');
				}, 50);
			};

			// Function for close ibox
			$scope.closebox = () => {
				let ibox = $element.closest('div.ibox');

				ibox.remove();

				$rootScope.$broadcast('sidebar.triggerResize');
			};

			if (typeof($attrs.iboxCollapsed) !== 'undefined') {
				$scope.showhide();
			}
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/iboxTools/index.js